<div class="row button-container mt-2">
    <div class="col-12 text-center">
        <div class="d-flex- float-end-">
            <button mat-stroked-button color="accent"
                *ngIf="artifact.key != ARTIFACT_KEY.PERSONAL && !ARTIFACT_TYPES_NON_REDO.includes(artifact.type)"
                (click)="reset();" 
                [disabled]="disableReset()"
            >Redo Section</button>
        </div>
    </div>
    <div class="p-3 determinate-progressbar">
        <mat-progress-bar
            mode="determinate"
            [value]="appWizService.appWizard.percentageComplete"
            bufferValue="100">
        </mat-progress-bar> 
    </div>
    <span class="d-flex justify-content-between align-items-center">
        <div class="d-flex float-start align-items-center">
            <button mat-stroked-button color="accent" class="d-none"
                *ngIf="![ARTIFACT_KEY.PERSONAL,ARTIFACT_KEY.MOREINFO].includes(artifact.key)"
                (click)="back()" 
                [disabled]="disablBackOrNext()"
            >Back</button>
            <button mat-raised-button color="accent" class="mx-2"
                *ngIf="!ARTIFACTS_SUBMIT.includes(artifact.key)"
                (click)="next()" 
                [disabled]="disablBackOrNext()"
            >Next</button>
            <button mat-raised-button color="accent" class="mx-2" 
                *ngIf="ARTIFACTS_SUBMIT.includes(artifact.key)"
                (click)="next()" 
                [disabled]="disablSubmit()"
            >Submit</button>
        </div>
    </span>
</div>